import React from 'react';
import api from "utils/api";
import "./Others.scss";
import Loader from 'Components/Loader';
import MHESummaryChild from './MHESummaryChild';
import { Empty} from "antd";
import MHESummaryNew from './MHESummaryNew';



export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resultObjects : [],
            isLoading:true
        };
    }

    componentDidMount() {
     this.getMheAnswerDetails();
    }

    getMheAnswerDetails(){
        api.get_mhe_answer_list({ patient_id: this.props.data?.patient_id, type: this.props?.data?.user_type ,version:"v2"})
        .then((res)=>{
            this.setState({resultObjects :res.data.data.results || [], isLoading: false });
        })
        .catch((err)=>{

        })
    }

    render() {
        return (
            <>
            {this.state.isLoading ? <Loader />  : 
            <div className="mhe-wrapper-container">
                <div className='mhe-header'>
                    <div>MSE</div>
                </div>
            <div className='mhe-content'>
            {this.state.resultObjects.length == 0 ? <Empty description={"No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE} /> : 
                this.state.resultObjects .map((data, val)=>{
                
                   if(data.version=="v2"|| data.version=="2" || data.version == "V2") return(
                        <React.Fragment key={val}>
                        {data.is_completed ?
                        <MHESummaryNew data={data} user_type={this.props.data.user_type} /> :  null
                        }
                        </React.Fragment>
                    )
                    if(data.version=="v1"|| data.version=="V1" || data.version == "1") return(
                        <React.Fragment key={val}>
                        {data.is_completed ?
                        <MHESummaryChild data={data} user_type={this.props.data.user_type} /> :  null
                        }
                        </React.Fragment>
                    )
                })}
            </div>                
            </div> }
            </>
        );
    }
}
